module.exports = __webpack_public_path__ + "img/southeast2.b4b7feca.jpg";